export default "__VITE_ASSET__BOzZhCZ9__"